<template>
	<v-app>
		<template v-if="!loading && isAuthorized">
			<v-change-password-dialog v-model="changePasswordDialog" :userId="userId"/>
			<navbar @change-password="changePasswordDialog = true" @change-drawer="drawer = !drawer"/>
			<navigation-drawer v-model="drawer"/>
		</template>
			
		<v-main>
			<v-layout v-if="(!loading && isAuthorized) || $route.name === 'login'" fill-height class="pa-3">
				<router-view style="width: 100%"/>
			</v-layout>
			<v-layout v-else-if="loading" fill-height column justify-center align-center>
				<v-progress-circular indeterminate size="40" color="primary"/>
				<div class="mt-2 text-h6">{{$t('loading')}} ...</div>
			</v-layout>
		</v-main>

		<v-snackbar
			v-model="snackbar"
			:color="snackbarColor + ' white--text'"
		>
			{{message}}

			<template v-slot:action="{ attrs }">
				<v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>
	</v-app>
</template>

<script>
import { mapState } from 'vuex';
import Navbar from './components/Navbar.vue';
import NavigationDrawer from './components/NavigationDrawer.vue';

export default {
	name: 'App',

	components: {
		Navbar,
		NavigationDrawer,
	},

	data() {
		return {
			drawer: false,
			loading: false,
			changePasswordDialog: false,

			snackbar: false,
			snackbarState: null,
			message: null,
		}
	},

	watch: {
		isAuthorized: {
			handler: function (val) {
				if (val) {
					this.loading = true;
					Promise.all([
						this.$store.dispatch('auth/fetchPermissions'),
						this.$store.dispatch('accounts/fetchAll'),
						this.$store.dispatch('items/fetchAll'),
						this.$store.dispatch('items/fetchTree'),
						this.$store.dispatch('configs/fetchAll').then(() => {
							this.$store.dispatch('configs/fetchConfigAccounts')
						}),
					]).finally(() => {
						this.loading = false;
					});
				} else {
					this.$store.dispatch('reset');
				}
			},
			immediate: true
		},

		'$i18n.locale'(val) {
			this.$vuetify.lang.current = val;
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		}
	},

	computed: {
		...mapState({
			userId: state => state.auth.self.userId,
			isAuthorized: state => state.auth.isAuthorized,
		}),
		snackbarColor() {
			switch (this.snackbarState) {
			case 'info': return 'primary';
			case 'warning': return 'warning-color';
			case 'error': return 'alert-color';
			default: return 'primary';
			}
		}
	},

	created() {
		this.$eventBus.$on('show-snackbar', (message, state = 'info') => {
			this.message = message;
			this.snackbarState = state;
			this.snackbar = true;
		});
	},

	metaInfo() {
		return {
			title: this.$T(`routes.${this.$route.meta.i18nTranslateKey}`),
			titleTemplate: '%s | Ugarit'
		}
	}
};
</script>

<style lang="scss">
@import '@/scss/main.scss';
@import '@beetronix/bee-components/lib/css/index.css';

#app {
	.v-icon {
		font-size: $icon-size;
	}
	.v-data-table, .v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--rounded), .v-menu__content {
		border-radius: $border-radius-root;
	}

	.bee-handy-smart-table {
		.v-input.mb-4 {
			margin-bottom: 8px !important;
		}

		.bee-handy-smart-table__input-cell {
			padding: 0 8px;
		}
	}

	.outline-container {
		border-radius: $border-radius-root + 5;
		border: 1px solid #ccc;
		padding: 5px;
	}

	.totals-row {
		background-color: white;
		position: sticky;
		bottom: 0;
		outline: 1px solid rgba(#000, .12);

		@media screen and (max-width: 600px) {
			display: none;
		}

		td {
			font-size: 12px;
			font-weight: 600;
			// padding-right: 2px !important;
			// padding-left: 2px !important;
		}
	}

	.statics-table {
		thead > tr:last-child > th {
			height: 0 !important;
		}
	}

	.tree-container {
		max-height: 90vh;
		overflow: auto;
	}
	.items-tree {
		max-width: 100%;
	}

	.primary-priority {
		&-1 {
			background-color: rgb(181, 220, 199);
		}
		&-2 {
			background-color: rgba(43, 171, 104, 0.3);
		}
	}
	.secondary-priority {
		&-1 {
			background-color: #cde0b6;
		}
		&-2 {
			background-color: rgba(121, 187, 46, 0.3);
		}
	}

	.thirdly-priority {
		@for $i from 1 through 10 {
			&-#{$i} {
				@if $i == 1 {
					background-color: #e5e598;
				}
				@else {
					background-color: rgba(#dfdf7e, 0.1 * (10 - $i));
				}
			}
		} 
	}
	.v-data-table--has-top { position: relative; }
	.print-btn {
		position: absolute;
		right: 0;
		z-index: 3;
	}
}

*::-webkit-scrollbar{
    height: 5px;
    width: 5px;
	background-color: #f8f8f8;
}
*::-webkit-scrollbar-thumb{
    background-color: #888;
    border-radius: 10px;
}
/* @supports (scrollbar-color: auto) {
	* {
		scrollbar-color: #888 #f8f8f8;
		scrollbar-width: thin;
	}
} */
</style>
